
export function AboutSettings() {
  return null
}